import styled from "styled-components";
import COLORS from "../../Common/Colors";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Card,
  Col,
  Row,
  Switch,
  Button,
  Badge,
  Avatar,
  Spin,
  Checkbox,
  Input,
  Select,
  Modal,
  Form,
  DatePicker,
} from "antd";
export const GreenSelect = styled(Select)`
  &.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
    background-color: #e8ffec !important;
    border-color: #b6e5b8;
  }
  .ant-select-selector {
    background-color: rgb(30, 190, 57) !important;
  }
`;
export const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid #000000;
  border-radius: 5px;
  background: transparent;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  margin: 10px;
  &:hover {
    border: 1px solid #000000;
    background: #f1f3f4;
    color: #000000;
  }
  &:focus {
    border: 1px solid #000000;
    background: #f1f3f4;
    color: #000000;
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;
export const ButtonLink = styled(Button)`
  .selectdropdown_responsive {
    background-color: red !important;
  }
  padding: 5px 20px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: ${COLORS.TEXT.SECONDARY};
  white-space: nowrap;
  outline: none;
  font-weight: 600;
  &:hover {
    outline: none;
    color: ${COLORS.TEXT.SECONDARY};
  }
  &:focus {
    outline: none;
  }
`;
export const ButtonFilled = styled(Button)`
  margin: 10px;
  padding: 5px 20px;
  border: none;
  width: 130px;
  height: 38px;
  border-radius: 26px;
  background: ${COLORS.PRIMARY} !important;
  font-weight: 500;
  font-size: 17px;
  color: white !important;
  white-space: nowrap;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: #00bc13 !important;
    color: white !important;
    font-size: 18px;
  }
  &:focus {
    background: #00bc13 !important;
    color: white;
    font-size: 18px;
  }
`;
export const Buttontransparent = styled(Button)`
  margin: 10px;
  padding: 5px 20px;
  border: none;
  width: 112px;
  height: 38px;
  border-radius: 26px;
  background: rgba(241, 241, 241, 0.8) !important;
  font-weight: 500;
  font-size: 17px;
  color: #2c963d !important;
  white-space: nowrap;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: rgba(178, 245, 178, 0.81) !important;
    color: #2c963d !important;
    font-size: 18px;
  }
  &:focus {
    background: rgba(178, 245, 178, 0.81) !important;
    color: #2c963d !important;
    font-size: 18px;
  }
`;
export const ButtonWhite = styled(Button)`
  margin: 10px;
  padding: 5px 20px;
  border: none;
  width: 15%;
  height: 28%;
  border-radius: 26px;
  background: #f1f1f1;
  border-color: none !important;
  font-weight: 500;
  font-size: 1.0625rem;
  color: #5f6d8c !important;
  white-space: nowrap;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    color: #2c963d !important;
    font-size: 1.0725rem;
  }
  &:focus,
  &:active {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    color: #2c963d !important;
    font-size: 1.0725rem;
  }
`;
// export const DashboardButton = styled(Button)`
//   margin: 10px;
//   padding: 5px 20px;
//   border: none;
//   width: 15%;
//   height: 28%;
//   border-radius: 26px;
//   border-color:none !important;
//   font-weight: 500;
//   font-size:  1.0625rem;
//   color: #5F6D8C !important;
//   white-space: nowrap;
//   cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
//   ${(props) =>
//     props.$active &&
//     `
//     background: #2c963d !important;
//     color: #f1f1f1 !important;
//     font-size: 1.0725rem;
//   `}
//   &:hover {
//   background: #2c963d !important;
//     color: #F1F1F1 !important;
//     font-size:  1.0725rem;
//   }
//   &:focus,
//   &:active {
//     border: none !important;
//     outline: none !important;
//     box-shadow: none !important;
//      background: #2c963d !important;
//     color: #F1F1F1 !important;
//     font-size:  1.0725rem;
//   }
// `;
export const DashboardButton = styled(Button)`
  margin: 10px;
  padding: 5px 20px;
  border: none;
  width: 15%;
  height: 28%;
  border-radius: 26px;
  background: #f1f1f1;
  border-color: none !important;
  font-weight: 500;
  font-size: 1.0625rem;
  color: #5f6d8c !important;
  white-space: nowrap;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  ${(props) =>
    props.$active &&
    `
      background: #2c963d !important;
      color: #F1F1F1 !important;
      font-size: 1.0725rem;
    `}
  &:hover {
    background: #2c963d !important;
    color: #f1f1f1 !important;
    font-size: 1.0725rem;
  }
  &:focus,
  &:active {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: #2c963d !important;
    color: #f1f1f1 !important;
    font-size: 1.0725rem;
  }
`;
export const DashboardNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const subscriptionList = useSelector(
    (state) => state?.authTracking?.subscriptionList
  );
  console.log("subs", subscriptionList);
  // Determine available dashboards
  const dashboards = [
    subscriptionList.includes("AI_DASH") && {
      path: "/Dashboard",
      label: "TrackRight AI",
    },
    subscriptionList.includes("CONT_DASH") && {
      path: "/container-dashboard",
      label: "TrackRight AI Cargo",
    },
    subscriptionList.includes("AIPLS_DSH") && {
      path: "/AIDashboard",
      label: "Trackright AI+",
    },
  ].filter(Boolean);
  // Auto-navigate if only one dashboard is available and not already on it
  useEffect(() => {
    if (dashboards.length === 1 && location.pathname !== dashboards[0].path) {
      navigate(dashboards[0].path, { replace: true });
    }
  }, [dashboards, location.pathname, navigate]);
  return (
    <>
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {/* Desktop Buttons */}
        <div
          className="desktop-dashboard-buttons"
          style={{ display: "flex", gap: "8px" }}
        >
          {subscriptionList.includes("AI_DASH") && (
            <DashboardButton
              onClick={() => navigate("/Dashboard")}
              style={{ minWidth: 160, minHeight: 50 }}
              $active={location.pathname === "/Dashboard"}
            >
              TrackRight AI
            </DashboardButton>
          )}
          {subscriptionList.includes("CONT_DASH") && (
            <DashboardButton
              onClick={() => navigate("/container-dashboard")}
              style={{ minWidth: 180, minHeight: 50 }}
              $active={location.pathname === "/container-dashboard"}
            >
              TrackRight AI Cargo
            </DashboardButton>
          )}
          {subscriptionList.includes("AIPLS_DSH") && (
            <DashboardButton
              onClick={() => navigate("/AIDashboard")}
              style={{ minWidth: 160, minHeight: 50 }}
              $active={location.pathname === "/AIDashboard"}
            >
              Trackright AI+
            </DashboardButton>
          )}
        </div>
        <div
          className="mobile-dashboard-dropdown"
          style={{ display: "none", width: "100%" }}
        >
          <Card
            style={{
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
              overflow: "visible",
              boxShadow: "none",
              padding: "0px !important",
              border: "none",
            }}
            bodyStyle={{
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
              overflow: "visible",
              padding: "20px 20px 0px 20px ",
            }}
          >
            <Select
              className="green_select"
              value={
                subscriptionList.includes("AI_DASH") &&
                location.pathname === "/Dashboard"
                  ? "TrackRight AI"
                  : subscriptionList.includes("CONT_DASH") &&
                    location.pathname === "/container-dashboard"
                  ? "TrackRight AI Cargo"
                  : subscriptionList.includes("AIPLS_DSH") &&
                    location.pathname === "/AIDashboard"
                  ? "Trackright AI+"
                  : undefined
              }
              onChange={(val) => {
                if (val === "TrackRight AI") navigate("/Dashboard");
                else if (val === "TrackRight AI Cargo")
                  navigate("/container-dashboard");
                else if (val === "Trackright AI+") navigate("/AIDashboard");
              }}
              style={{ width: "100%" }}
              dropdownStyle={{
                backgroundColor: "#fff", // 👈 White dropdown background
                color: "#2C963D",
              }}
            >
              {subscriptionList.includes("AI_DASH") && (
                <Select.Option value="TrackRight AI">
                  TrackRight AI
                </Select.Option>
              )}
              {subscriptionList.includes("CONT_DASH") && (
                <Select.Option value="TrackRight AI Cargo">
                  TrackRight AI Cargo
                </Select.Option>
              )}
              {subscriptionList.includes("AIPLS_DSH") && (
                <Select.Option value="Trackright AI+">
                  Trackright AI+
                </Select.Option>
              )}
            </Select>
          </Card>
          {/* Inline style targeting .ant-select-selector and dropdown */}
          <style>
            {`
      /* Main select box styling */
      .green_select .ant-select-selector {
        background-color: #E8FFEC !important;
        color: #2C963D !important;
        border-color: #E8FFEC !important;
      }
      /* Selected text color */
      .green_select .ant-select-selection-item {
        color: #2C963D !important;
        font-weight: 500;
      }
      /* Dropdown menu background */
      .green_select .ant-select-dropdown {
        background-color: #ffffff !important;
      }
      /* Dropdown option text color */
      .green_select .ant-select-item-option {
        color: #2C963D !important;
      }
      /* Highlighted option hover effect */
      .green_select .ant-select-item-option-active {
        background-color: #E8FFEC !important;
      }
    `}
          </style>
        </div>
        {/* Responsive CSS */}
        <style>
          {`
      @media (max-width: 768px) {
        .desktop-dashboard-buttons { display: none !important; }
        .mobile-dashboard-dropdown { display: block !important;
        }
      }
      @media (min-width: 769px) {
        .desktop-dashboard-buttons { display: flex !important; }
        .mobile-dashboard-dropdown { display: none !important; }
      }
    `}
        </style>
      </div>
    </>
  );
};
export const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    width: 24px !important;
    height: 24px !important;
    border-radius: 6px !important;
    border-color: #4caf50 !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #4caf50 !important;
    border-color: #4caf50 !important;
  }
  .ant-checkbox-inner::after {
    width: 7px !important;
    height: 12px !important;
    left: 30% !important;
    top: 45% !important;
  }
  &:hover .ant-checkbox-inner {
    border-color: #4caf50 !important;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #4caf50 !important;
    border-color: #4caf50 !important;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: white !important;
    width: 14px !important;
    height: 2px !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
`;